/** @jsx React.DOM */
/**
 * Base nav component.
 */
var React = require("react");
var Backbone = require("exoskeleton");

module.exports = React.createClass({displayName: 'exports',
  goHome: function (ev) {
    ev.preventDefault();
    Backbone.history.navigate("", { trigger: true });
  },

  render: function () {
    return (/*jshint ignore:start */
      React.createElement("nav", {className: "navbar navbar-default", role: "navigation"}, 
        React.createElement("div", {className: "navbar-header"}, 
          React.createElement("button", {type: "button", className: "navbar-toggle", 
                  'data-toggle': "collapse", 'data-target': "#nav-target"}, 
            React.createElement("span", {className: "sr-only"}, "Toggle navigation"), 
            React.createElement("span", {className: "icon-bar"}), 
            React.createElement("span", {className: "icon-bar"}), 
            React.createElement("span", {className: "icon-bar"})
          ), 
          React.createElement("a", {className: "navbar-brand", href: "/", onClick: this.goHome}, "Notes")
        ), 

        React.createElement("div", {className: "collapse navbar-collapse", id: "nav-target"}, 
          this.props.children
        )
      )
    /*jshint ignore:end */);
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/nav/base.jsx
 ** module id = 98
 ** module chunks = 0
 **/